const CustGroupQuery = () =>
  import('@/views/main/helper/custGroup/CustGroupQuery.vue')
export default {
  path: '/main/custGroup/query',
  name: 'CustGroupQuery',
  component: CustGroupQuery,
  children: []
}
